import type { IModalText, ISharing } from "app/components/sharingAssetModal/types";
import { ESharingState } from "app/components/sharingAssetModal/types";

const { PRIVATE, SUBSET_OF_USERS, ACCOUNT } = ESharingState;

export const getInitialSharingStateHof =
    (initialSharingState: ESharingState, initialSharedWithUsers: Array<number>, modalText: IModalText) =>
    (): ISharing => {
        return {
            sharingState: initialSharingState,
            sharedWithUsers: initialSharedWithUsers,
            notification: {
                shouldNotify: false,
                notificationContent: modalText.sharingStateContainer[SUBSET_OF_USERS].notificationDefaultContent,
            },
        };
    };

//MD means MetaDate - by using this function, you can get the relevant tracking texts for the previous state and the new state
export const getTrackingMD = (shouldNotify: boolean) => {
    return {
        previousState: {
            [PRIVATE]: "Start_private",
            [ACCOUNT]: "Start_organization",
            [SUBSET_OF_USERS]: "Start_restricted",
        },
        newState: {
            [PRIVATE]: "End_private",
            [ACCOUNT]: "End_organization",
            [SUBSET_OF_USERS]: shouldNotify ? "End_restricted_notif" : "End_restricted",
        },
    };
};
